/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  
  cancelridebydispatcheroradmin: (data) => {
  // console.log('createride-->',data)
  return axios.post(API_ENDPOINTS.CANCEL_RIDE_BY_DISPATCHER_OR_ADMIN, data, {
    headers: {
      isAuthRequired: true,
      "Content-Type": "application/json",
    },
  });
  },
  gettriplists: (params) => {
    return axios.get(API_ENDPOINTS.GET_TRIP_LISTS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getoverallstatement: (params) => {
    return axios.get(API_ENDPOINTS.GET_TRIP_LISTS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getoverallstatement_corp: (params) => {
    return axios.get(API_ENDPOINTS.GET_TRIP_LISTS_CORP, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getoverallstatement_corp_daily: (params) => {
    return axios.get(API_ENDPOINTS.GET_TRIP_LISTS_CORP_DAILY, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getoverallstatement_corp_monthly: (params) => {
    return axios.get(API_ENDPOINTS.GET_TRIP_LISTS_CORP_MONTHLY, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getoverallstatement_corp_yearly: (params) => {
    return axios.get(API_ENDPOINTS.GET_TRIP_LISTS_CORP_YEARLY, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },  
  getdriversinfo: (params) =>{
    return axios.get(API_ENDPOINTS.GET_DRIVERS_INFO, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getridesofdriver: (params) =>{
    return axios.get(API_ENDPOINTS.GET_RIDES_OF_DRIVER, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getfilteredtriplist: (params) =>{
    return axios.get(API_ENDPOINTS.GET_FILTERED_TRIP_LISTS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params
    });
  },
  getdriversandservices: () => {
    return axios.get(API_ENDPOINTS.GET_DRIVERS_AND_SERVICES, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" }
    });
  },
  getselectedservicedrivers: (id) => {
    //console.log('idddd->',id);
    return axios.get(API_ENDPOINTS.GET_SELECTED_SERVICE_DRIVERS+ "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" }
    });
  },
  getselectedridestatus: (params) => {
    //console.log('data->',params);
    return axios.get(API_ENDPOINTS.GET_SELECTED_RIDE_STATUS_DRIVERS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params
    });
  },
  createridebydispatcher: (data) => {
   // console.log('createride-->',data)
    return axios.post(API_ENDPOINTS.CREATE_NEW_RIDE_BY_DISPATCHER, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
  assignridebydispatcher: (data) => {
    return axios.post(API_ENDPOINTS.ASSIGN_NEW_RIDE_BY_DISPATCHER, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
  fetchnearbydrivers: (data) => {
    let url = `${API_ENDPOINTS.FETCH_NEARBY_DRIVERS}`;
    return axios.post(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  }, 
};
